export interface TnCAcceptanceStatus {
  version: number;
  accepted: boolean;
}

export interface TnCContent {
  content: string;
  version: number;
}

export interface AcceptedTnCsResponse {
  acceptedTncs: unknown;
}

export async function checkTnCAcceptance(
  username: string,
  tenant: string,
): Promise<TnCAcceptanceStatus> {
  const response = await fetch(
    `/api/advisor/registration-service/tncs/${encodeURIComponent(username)}/accepted?tenant=${encodeURIComponent(tenant)}`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
    },
  );

  if (!response.ok) {
    throw new Error(`T&C acceptance check failed: ${response.status}`);
  }

  return response.json();
}

export async function fetchTnCContent(tenant: string): Promise<TnCContent> {
  const response = await fetch(
    `/api/advisor/registration-service/tncs?tenant=${encodeURIComponent(tenant)}`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
    },
  );

  if (!response.ok) {
    throw new Error(`T&C content fetch failed: ${response.status}`);
  }

  return response.json();
}

export async function acceptTnC(
  userName: string,
  tenant: string,
  version: number,
  accessToken: string,
): Promise<void> {
  const response = await fetch("/api/advisor/registration-service/tncs", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ userName, tenant, version }),
  });

  if (!response.ok) {
    throw new Error(`T&C acceptance failed: ${response.status}`);
  }
}

export async function fetchAcceptedTnCs(
  accessToken: string,
): Promise<AcceptedTnCsResponse> {
  const response = await fetch(
    "/api/advisor/registration-service/tncs/accepted",
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Accepted T&C versions fetch failed: ${response.status}`);
  }

  return response.json();
}
